import {
	ADMINGETINTEGRATIONTYPELIST_SUCCESS,
	ADMINGETINTEGRATIONTYPELIST_FAILED,
	RESET_ADMINGETINTEGRATIONTYPELIST,
	LOADING_ADMINGETINTEGRATIONTYPELIST,
	NETWORK_ERROR_ADMINGETINTEGRATIONTYPELIST
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminGetIntegrationTypeList = () => {
	return { type: RESET_ADMINGETINTEGRATIONTYPELIST };
};

const adminGetIntegrationTypeList =
	(userData, authTokenIs) => async (dispatch) => {
		dispatch({ type: LOADING_ADMINGETINTEGRATIONTYPELIST });
		await adminServices
			.post("getIntegrationTypeList", userData, { headers: { AuthToken: authTokenIs } })
			.then((res) => {
				switch (res.data.status) {
					case "success":
						dispatch(adminGetIntegrationTypeListsuccess(res.data));
						break;
					default:
						dispatch(adminGetIntegrationTypeListFailed(res.data));
						break;
				}
			})
			.catch((err) => {
				dispatch({
					type: NETWORK_ERROR_ADMINGETINTEGRATIONTYPELIST,
					payload: err
				});
			});
	};
function adminGetIntegrationTypeListsuccess(data) {
	return {
		type: ADMINGETINTEGRATIONTYPELIST_SUCCESS,
		payload: data
	};
}
function adminGetIntegrationTypeListFailed(data) {
	return {
		type: ADMINGETINTEGRATIONTYPELIST_FAILED,
		payload: data
	};
}

export { resetAdminGetIntegrationTypeList, adminGetIntegrationTypeList };
